import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    EventHeaderGroupSelection,
    EventHeaderGroupSelectionsContainer,
} from 'src/domains/sportsbook/webview/components/eventsList/eventGroupHeader6Pack/EventsGroupHeader6Pack.style';
import { Collapse } from 'src/ui/components/collapse/sports/03/Collapse';
import { Collapse as CollapseUnified } from 'src/ui/components/collapse/sports/05/Collapse';
import { useCommon } from 'src/domains/common/Common';
import { BreakpointsState } from 'src/domains/layouts/state/breakpointsState/BreakpointsState';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface EventGroupHeaderPropsType {
    dataTest?: string;
    label: string;
    marketNames: [string, string, string];
    onToggle: () => void;
    open: boolean;
}

export const EventGroupHeader6Pack = observer('EventGroupHeader6Pack', (props: EventGroupHeaderPropsType) => {
    const { dataTest, label, open, marketNames, onToggle } = props;
    const common = useCommon();
    const breakpointsState = BreakpointsState.get(common);
    const {
        unifiedSportEventsTable,
        componentVariants: { sportsbookVariant },
    } = ConfigComponents.get(common).unifiedComponentConfig;
    const isLabelsVisible = open && breakpointsState.desktop.isBiggerOrEq;
    const CollapseComponent = unifiedSportEventsTable ? CollapseUnified : Collapse;

    const selectionLabels =
        isLabelsVisible === true
            ? marketNames.map((marketName) => {
                  return (
                      <EventHeaderGroupSelection
                          key={marketName}
                          variant={sportsbookVariant}
                          isUnifiedEvents={unifiedSportEventsTable}
                      >
                          {marketName}
                      </EventHeaderGroupSelection>
                  );
              })
            : null;

    return (
        <CollapseComponent
            handleToggle={onToggle}
            className='event-group-header--6-pack'
            isOpen={open}
            title={label}
            dataTest={dataTest}
            collapsible={unifiedSportEventsTable === false}
        >
            {selectionLabels === null ? null : unifiedSportEventsTable === true ? (
                <EventHeaderGroupSelectionsContainer variant={sportsbookVariant}>
                    {selectionLabels}
                </EventHeaderGroupSelectionsContainer>
            ) : (
                selectionLabels
            )}
        </CollapseComponent>
    );
});
